import React from "react";
import { Box } from "@mui/system";
import { Radio, FormControlLabel, RadioGroup } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { QuestionFooter } from "./QuestionFooter";


export function SingleChoiceComponent({
  initialValues,
  question,
  options = [],
  addAnswer,
  previous,
  next,
  loadingAnswer
}) {
  options = options.map((each, index) => ({...each, sequenceNumber: each?.sequenceNumber ?? index }) )
  const { handleSubmit, values, setFieldValue, isValid, setSubmitting, errors } = useFormik({
    initialValues: {
      answer: initialValues?.answerText ?? "",
      required: !!question?.required,
    },
    validationSchema: Yup.object().shape({
      required: Yup.boolean(),
      answer: Yup.string()
        .trim()
        .required("Es muss eine Antwort ausgewählt werden.")
    }),
    onSubmit: async (values) => {
      if (!values.answer.trim()) {
        setSubmitting(false);
        return;
      }
      setSubmitting(true);
      const answer = {
        questionId: question.id,
        answerText: values.answer,
      };
      const proceed = await addAnswer(question.id, [answer]);
      if (proceed) {
        setSubmitting(false);
        next();
      }
    },
  });
  

  const handleChange = (event) => {
    if (values.answer === event.target.value) {
      setFieldValue("answer", '');
    } else {
      setFieldValue("answer", event.target.value);
    }
  };

  return (
    <div className="survey-choice">
      <div className="survey-answer-list">
      {options
        .sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1))
        .map((eachOption) => (
          <div key={eachOption.sequenceNumber} className="survey-answer-item">
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={values.answer}
            
              onClick={handleChange}
            >
              <FormControlLabel
                value={eachOption.text}
                control={
                  <Radio
                  checked={values.answer === eachOption.text}
                    sx={{
                      padding: "0px",
                      "& svg": {
                        width: "31px",
                        height: "31px",
                        padding: "0px",
                        color: "#238CB9",
                      },
                    }}
                  />
                }
                label={eachOption.text}
                sx={{
                  alignItems: "start !important",
                  color: "#238CB9",
                  padding: "0px",
                  "& .MuiFormControlLabel-label": {
                    marginLeft: "18px",
                  },
                }}
                labelPlacement="end"
              />
            </RadioGroup>
          </div>
        ))}
      </div>
      
      <QuestionFooter
        back={previous}
        onSave={handleSubmit}
        isSubmitting={loadingAnswer}
        isValid={isValid}
        showErrorModal={
          typeof errors?.answer === "string" && errors.answer.length > 0
            ? errors.answer
            : ""
        }
      />
    </div>
  );
}
